<template>
<div>
  <div class="maren-sol">
    <el-container class="d-flex-column">
      <h1>Maren <span class="d-block">Solutions</span></h1>
      <p style="font-size: 18px;">We are committed to building Relationships<span class="d-block"></span></p>
    </el-container>
  </div>
  <div class="maren-comm">
    <el-container class="d-flex-column">
      <el-row :gutter="20">
        <el-col :span="10">
          <img src="../../../public/img/home/communicate.svg" class="img-responsive" alt="Communicate">
        </el-col>
        <el-col :span="14">
          <h2>Communicate <span class="d-block">Collaborate and</span> Growth</h2>
          <p>With worldly wise of experience in designing, and delivering complex software application, 
            we believe our team a blend of on-shore and off-shore talent creating tailored software products. we ensure that the final solution is eminent and well documented <!--<a href="javascript:void(0);">Read more</a>--></p>
        </el-col>
      </el-row>
    </el-container>
  </div>
  <div class="maren-vision">
    <el-container class="d-flex-column">
      <ul class="vision-list">
        <li>
          <h2>Vision of <span class="d-block">Maren Solutions</span></h2>
          <h5>We are committed to building relationships.</h5>
        </li>
        <li>
          <img src="../../../public/img/home/diamond.svg" alt="Diamond">
          <h4>Value & Importance</h4>
          <p>Maren solutions values the <span class="d-block">importance of open</span> communication</p>
        </li>
        <li>
          <img src="../../../public/img/home/promises.svg" alt="Promises">
          <h4>Promises</h4>
          <p>We adhere to our promises and <span class="d-block">meet the deadlines</span></p>
        </li>
        <!--<li>
          <img src="../../../public/img/home/will-fix.svg" alt="Diamond">
          <h4>We will fix it</h4>
          <p>If something doesn't work the way <span class="d-block">we said it would,</span> we will fix it</p>
        </li>--->
        <li>
          <img src="../../../public/img/home/output.svg" alt="Promises">
          <h4>Best Output</h4>
          <p>We provide Collaborate <span class="d-block">training for the best output</span></p>
        </li>
        <li>
          <img src="../../../public/img/home/relationship.svg" alt="Diamond">
          <h4>Relationship</h4>
          <p>With decades of domain knowledge, our subject matter experts provide insightful information to enhance our customer relationship</p>
        </li>
        <li>
          <img src="../../../public/img/home/support.svg" alt="Promises">
          <h4>Implementation and support</h4>
          <p>For additional long-term security, we offer support contracts that includes software maintainance and enhancements</p>
        </li>
      </ul>
    </el-container>
    <img src="../../../public/img/home/objects.svg" alt="Object" class="objects">
  </div>
</div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
  export default {
  watch:{
  },
    computed: mapState(['currentLanguage']),
    title () {
      return this.currentLanguage == 'en' ? '' : ''
    },
    components:{  },
    data() {
      return {
          scobj: false,
          sobj: {}
        }
      },
        async created() {
    let response = await this.$store.dispatch("FETCH_SSC", this);
localStorage.setItem('FTR', JSON.stringify(response.FTR)),
localStorage.setItem('FTD', JSON.stringify(response.FTD))
  },
      methods: {
        toggleBodyClass(addRemoveClass, className) {
          const el = document.body;

          if (addRemoveClass === 'addClass') {
            el.classList.add(className);
          } else {
            el.classList.remove(className);
          }
        },
      },
        mounted() {
          this.toggleBodyClass('addClass', 'home');
        },
        destroyed() {
          this.toggleBodyClass('removeClass', 'home');
        }
    };
</script>


// WEBPACK FOOTER //
// Home.vue